module.exports = __webpack_public_path__ + "static/media/clean-drinking-water-2.00e971ec.jpeg";